$(document).ready(function() {
// Product main slider
  $('.main_slider .slider-button').click(function(){
    var btnprevnext = $(this).attr('name');
    if(btnprevnext == 'next'){
          $('.thumbnail-list .active_thumb').next().find('button').trigger('click');
    }else{
          $('.thumbnail-list .active_thumb').prev().find('button').trigger('click');
    }

})

  
  //Product page tabs
  $('.product_details .product_details-tab').click(function () {
    var currenttab = $(this);
    $('.product_details-tab').removeClass('active');
    currenttab.addClass('active');
    $('.product_details-tabcontent').removeClass('active');
    var currenttabId = currenttab.attr('data-id');
    $('#'+currenttabId).addClass('active');
  })

  var interval;
  var count = 0;
  function recommendations(){
     $('product-recommendations ul').slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      rows: 0,
      responsive: [
        {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '20px',
              slidesToScroll: 1,
              autoplay: true
            }
        }
      ]
    });
  }
  function countUp(){
    var pr = document.getElementsByTagName("product-recommendations")[0].getElementsByClassName('grid__item');
    var pr_length = pr.length;
  
    if(pr_length > 0){
      count++;
    }
    if(count > 1){
      clearInterval(interval);
      recommendations();
    }
  }
  countUp();
  interval = setInterval(countUp, 200);

  $(window).on('resize orientationchange', function() {
      var interval;
  var countresize = 0;
    
      function countUp(){
    var pr = document.getElementsByTagName("product-recommendations")[0].getElementsByClassName('grid__item');
    var pr_length = pr.length;
  
    if(pr_length > 0){
      countresize++;
    }
    if(countresize > 1){
      clearInterval(interval);
      $('product-recommendations ul').slick('resize');
    }
  }
  countUp();
  interval = setInterval(countUp, 200);
  });
  
});